import React from "react";
import { ItemComponentProps } from "@webscopeio/react-textarea-autocomplete";

export type UserAutocompleteItemDto = {
  name: string;
  companyName: string;
  code: string;
  isOtherCompany: boolean;
};

export const UserAutocompleteItem: React.FC<ItemComponentProps<string | object>> = props => {
  const item = props.entity as UserAutocompleteItemDto;

  const companyNameString = item.isOtherCompany ? ` (${item.companyName})` : "";

  return <div>{`${item.name}${companyNameString}`}</div>;
};
